export enum StompConnectionStatus {
    OK = 'OK',
    DUPLICATE_LOGIN = 'DUPLICATE_LOGIN',
    DISCONNECTED = 'DISCONNECTED',
    CONNECTION_ENDED = 'CONNECTION_ENDED',
    DESTROYED = 'DESTROYED',
    EXCEEDED_MAXIMUM_USERS = 'EXCEEDED_MAXIMUM_USERS'
}
